<template>
  <div id="sidebar" class="w-full h-full relative flex flex-col items-center overflow-hidden text-gray-400 bg-secondary">
    <div class="w-full h-full p-0">
      <div class="w-full">
        <div >
          <div class="h-[var(--admin-header-height)] admin-header-top-row bg-black flex items-center justify-between w-full px-4">
            <NuxtLink :to="{path: ROUTESNAMES[role].dashboard }" class="hide-if-close h-full flex items-center">
              <img class="w-20 max-w-full mx-auto" src="@/assets/images/logo.svg" alt="logo" />
            </NuxtLink>
            <button @click="() => toggleSidebar && toggleSidebar()" class="h-full flex items-center">
                <svg :class="`mobile-menu-button  ${!isSidebarOpen ? 'active' : ''}`" width="30" height="30" viewBox="0 0 40 26" xmlns="http://www.w3.org/2000/svg">
                <rect class="mobile-menu-button-top" width="24" height="3.5" rx="3" ry="3" />
                <rect class="mobile-menu-button-middle" width="24" height="3.5" y="12" rx="3" ry="3" />
                <rect class="mobile-menu-button-bottom" width="24" height="3.5" y="23" rx="3" ry="3" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <ul class="dashboard-list overflow-y-auto h-dvh w-full sidebar-inner m-0 ">
        <slot/>
      </ul>
    </div>
  </div>
</template>

<script>
import { ROUTESNAMES } from "@/helpers";
import ItemDropdown from './ItemDropdown.vue';

export default {
  components: { ItemDropdown },
  data() {
    return {
      logoutModal: false,
      ROUTESNAMES
    };
  },
  props: {
    isSidebarOpen: {
      type: Boolean,
      required: true,
      default: false
    },
    toggleSidebar:{
      type: Function,
      required: true
    },
    role: {
      type: String,
      required: true,
      default: "admin"
    }
  },
  methods: {
    closeModal() {
      this.logoutModal = false;
    },
  },
};
</script>

<style lang="scss" scoped >
#sidebar .dashboard-list .sidebar-list-item {
  transition: 0.25s linear;
  transition-property: background-color, color, font-weight, padding-left;
  font-weight: 500;
  border-left: 2px solid transparent;
  font-size: 0.890em;
}
#sidebar .dashboard-list .sidebar-list-item span{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
#sidebar .dashboard-list .sidebar-list-item span.hide-if-close {
  transition: all 0.25s linear;
}
#sidebar .dashboard-list .sidebar-list-item:hover span.hide-if-close {
  margin-right: 0.5rem;
  margin-left: 0;
}
#sidebar .sidebar-dropdown-header{
  cursor: pointer;
  user-select: none;
}

html[dir="rtl"].rtl {
  #sidebar .dashboard-list .sidebar-list-item{
  transition-property: background-color, color, font-weight, padding-right;
  border-right: 2px solid transparent;
    &:hover span.hide-if-close{
      margin-left: 0.5rem;
      margin-right: 0;
    }
  }
}
</style>
